import { render } from "./RightLine.vue?vue&type=template&id=54de3dd7"
import script from "./RightLine.vue?vue&type=script&lang=js"
export * from "./RightLine.vue?vue&type=script&lang=js"
script.render = render

export default script